import MainMeterForm from './MainMeterForm';

const AddMainMeter = () => {
    return <MainMeterForm isUpdate={false} />;
};

export default AddMainMeter;
